'use strict'

const multiaddr = require('multiaddr')

function ensureMultiaddr (ma) {
  if (multiaddr.isMultiaddr(ma)) {
    return ma
  }

  return multiaddr(ma)
}

module.exports = {
  ensureMultiaddr: ensureMultiaddr
}



//////////////////
// WEBPACK FOOTER
// ./~/peer-info/src/utils.js
// module id = 297
// module chunks = 0